"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDateField = void 0;
const date_field_1 = require("../date-field/date-field");
exports.LocalDateField = date_field_1.DateField;
//# sourceMappingURL=local-date-field.js.map